import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack } from '@mui/material';
import PrimaryButton from '../Button/primary-button.js';

const DetailsView = ({
	mainTitle,
	isMobile,
	pdfHeaderList,
	data,
	forwardToEntityBtn,
	forwardToEntityBtnAccept,
	rejectOnclick
}) => {
	const borderStyle = {
		borderRightWidth: '1px',
		borderTopWidth: '1px',
		borderBottomWidth: '0px',
		borderLeftWidth: '0px',
		borderStyle: 'solid',
		borderColor: '#8E8E8E'
	};

	return (
		<Box flex={1} maxWidth='400px' display='flex' flexDirection='column'>
			<Box
				sx={{
					width: '100%',
					padding: '24px 0px',
					backgroundColor: 'black',
					color: '#D9D9D9',
					position: 'relative'
				}}
				className='custom-scrollbar'
			>
				{!isMobile && (
					<Stack pl={'24px'} display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
						<Box className={'semiBold15'}>{mainTitle}</Box>
					</Stack>
				)}

				<Box
					pl={'24px'}
					sx={{
						overflow: 'auto',
						maxHeight: '70vh',
						height: '69vh',
						width: '100%',
						WebkitScrollbar: {
							display: 'none'
						}
					}}
				>
					{Object.keys(pdfHeaderList)?.map((val, i) => {
						if (val.includes('isTable')) {
							return (
								<Box sx={{ marginTop: '8px' }} key={'mainbox' + val + i}>
									<table
										style={{
											border: '1px solid #8E8E8E',
											borderSpacing: '0px',
											borderRadius: '10px',
											tableLayout: 'fixed',
											width: '100%'
										}}
									>
										<tbody>
											<tr>
												<th
													style={{
														padding: '5px',
														verticalAlign: 'middle',
														textAlign: 'center',
														color: '#8E8E8E',
														borderRightWidth: '1px',
														borderTopWidth: '0px',
														borderBottomWidth: '0px',
														borderLeftWidth: '0px',
														borderStyle: 'solid',
														borderColor: '#8E8E8E'
													}}
												>
													<Box className={'medium11'}>Denominations</Box>
												</th>
												<th style={{ padding: '5px', verticalAlign: 'middle', textAlign: 'center' }}>
													<Box className={'medium11'} style={{ wordWrap: 'break-word', color: '#8E8E8E' }}>
                            Quantity
													</Box>
												</th>
											</tr>

											{pdfHeaderList[val]?.map((res, i) => (
												<tr style={{ ...borderStyle }} key={'res' + res.col1 + i}>
													<td
														colSpan='0.5'
														style={{
															...borderStyle,
															verticalAlign: 'top',
															textAlign: 'center',
															color: '#8E8E8E',
															padding: '8px'
														}}
													>
														<Box style={{ color: '#D9D9D9' }} className={'medium11'}>
															{res.denomination}
														</Box>
													</td>
													<td
														style={{
															...borderStyle,
															borderRightWidth: '0px',
															verticalAlign: 'top',
															textAlign: 'center',
															padding: '8px'
														}}
													>
														<Box className={'medium11'} style={{ wordWrap: 'break-word', color: '#D9D9D9' }}>
															{res.quantity}
														</Box>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</Box>
							);
						}

						return (
							<Box key={'else' + val}>
								<Box sx={{ marginTop: '16px', marginBottom: '8px' }} className={'medium11'}>
									{val + ':'}
								</Box>
								<table style={{ tableLayout: 'fixed', border: '0px', width: '100%' }}>
									<tbody>
										{pdfHeaderList[val]?.map((res) => (
											<tr key={res.title}>
												<td colSpan='0.5' style={{ verticalAlign: 'top', color: '#8E8E8E', paddingTop: '3px' }}>
													<Box className={'medium11'}>{res.title + ' : '}</Box>
												</td>
												<td style={{ verticalAlign: 'top' }}>
													<Box style={{ wordWrap: 'break-word', color: '#D9D9D9' }}>{data[res.keyName] || '-'}</Box>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</Box>
						);
					})}
				</Box>
			</Box>
			{!forwardToEntityBtn && (
				<Box
					display={'flex'}
					gap={'8px'}
					paddingX={isMobile ? '24px' : '0px'}
					mb={isMobile ? '24px' : '0px'}
					sx={{
						marginLeft: isMobile ? '0px' : '24px',
						position: 'static',
						marginTop: '-30px',
						width: isMobile ? '100%' : 'calc(100% - 24px)'
					}}
				>
					<PrimaryButton
						value={'Reject'}
						marginTop='18px'
						onClick={rejectOnclick}
						backgroundColor='#0A0909'
						textcolor='#E96666'
						border='1px solid #E96666'
						height='40px'
						width='100%'
						padding='10px 16px'
					/>
					<PrimaryButton
						className={'semiBold14'}
						marginTop='18px'
						width='100%'
						height='40px'
						value={'Forward to Entity'}
						borderRadius={'8px'}
						fontWeight={400}
						textcolor={'#21241E'}
						backgroundColor={'#B7D423'}
						onClick={forwardToEntityBtnAccept}
					/>
				</Box>
			)}
		</Box>
	);
};

DetailsView.propTypes = {
	mainTitle: PropTypes.string,
	isMobile: PropTypes.bool,
	pdfHeaderList: PropTypes.any,
	data: PropTypes.any,
	forwardToEntityBtn: PropTypes.bool,
	forwardToEntityBtnAccept: PropTypes.func,
	rejectOnclick: PropTypes.func
};

export default DetailsView;
